import type { PhaseKey, Site } from '$lib/types';

type CoordSource = 'map' | 'gps' | 'drag';

interface SiteFormData {
  name: string;
  sub: string;
  solar: boolean;
  cabinet: boolean;
  phase: PhaseKey;
  area: number;
  lat: number | '';
  lng: number | '';
}

function blank(): SiteFormData {
  return {
    name: '',
    sub: '',
    solar: true,
    cabinet: false,
    phase: 'planned',
    area: 200,
    lat: '',
    lng: '',
  };
}

let open = $state(false);
let editId = $state<string | null>(null); // sites.id being edited (null = create)
let editVid = $state<string | null>(null);
let pickingLoc = $state(false);
let error = $state<string | null>(null);
let saving = $state(false);
let data = $state<SiteFormData>(blank());
// How the current coordinates were set, for site_added/site_updated analytics.
// Reset on openAdd/openEdit; null means "unchanged from the loaded site".
let coordSource = $state<CoordSource | null>(null);

export const form = {
  get open() {
    return open;
  },
  get editing() {
    return !!editId;
  },
  get editId() {
    return editId;
  },
  get editVid() {
    return editVid;
  },
  get pickingLoc() {
    return pickingLoc;
  },
  set pickingLoc(v: boolean) {
    pickingLoc = v;
  },
  get error() {
    return error;
  },
  set error(v: string | null) {
    error = v;
  },
  get saving() {
    return saving;
  },
  set saving(v: boolean) {
    saving = v;
  },
  get data() {
    return data;
  },
  get coordSource() {
    return coordSource;
  },

  openAdd() {
    data = blank();
    editId = null;
    editVid = null;
    coordSource = null;
    error = null;
    open = true;
  },
  openEdit(site: Site) {
    data = {
      name: site.name,
      sub: site.sub,
      solar: site.hasSolar,
      cabinet: site.hasCabinet,
      phase: site.phase,
      area: site.area,
      lat: site.lat,
      lng: site.lng,
    };
    editId = site.vid || site.id;
    editVid = site.vid;
    coordSource = null;
    error = null;
    open = true;
  },
  close() {
    open = false;
    pickingLoc = false;
    error = null;
  },
  setCoord(lat: number, lng: number, source?: CoordSource) {
    data.lat = +lat.toFixed(6);
    data.lng = +lng.toFixed(6);
    if (source) coordSource = source;
  },
};
